import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./afterSaleDatatable";
import { getAllAfterSaleRedux } from "../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Search } from "react-feather";
import MakeRefundAfterSaleModal from "./makeRefundAfterSaleModal";

class RefundRequestOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFor: "",
      open: false,
      toggleModal: true,
      payableOrders: [],
      refundRequest: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllAfterSaleRedux();
  };

  startToggleModal = async (refundRequest) => {
    if (refundRequest) {
      this.setState({
        toggleModal: false,
        refundRequest,
      });
    } else {
      this.setState({
        toggleModal: true,
        refundRequest: null,
      });
    }
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  getRefundRequestArray = () => {
    console.log(this.props.allRefundRequests);
    if (!this.state.searchFor) {
      return this.props.allRefundRequests;
    }

    let filterByStatus = this.props.allRefundRequests.filter((refundRequest) =>
      refundRequest.status
        .toLowerCase()
        .includes(this.state.searchFor.toLowerCase())
    );
    let filterByMethod = this.props.allRefundRequests.filter((refundRequest) =>
      refundRequest.method
        .toLowerCase()
        .includes(this.state.searchFor.toLowerCase())
    );

    return [...filterByStatus, ...filterByMethod];
  };

  render() {
    const { open } = this.state;

    return (
      <Fragment>
        <MakeRefundAfterSaleModal
          toggleModal={this.state.toggleModal}
          startToggleModal={this.startToggleModal}
          payableOrders={this.state.payableOrders}
          refundRequestObj={this.state.refundRequest}
        />
        <Breadcrumb title="Refund Request" parent="Payment" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div
                  className="card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>
                    {" "}
                    <i
                      className="fas fa-money-check-alt"
                      style={{
                        fontSize: "180%",
                        marginRight: "5px",
                        marginTop: "5px",
                        color: "#ff8084",
                      }}
                    ></i>
                    Refund Request
                  </h5>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                    }}
                  >
                    {" "}
                    <li
                      style={{
                        border: "1px solid gainsboro",
                        borderRadius: "5rem",
                        padding: "0px 20px",
                        background: "whitesmoke",
                        marginRight: "20px",
                      }}
                    >
                      <form
                        className="form-inline search-form"
                        onSubmit={this.handleSubmit}
                      >
                        <div
                          // className="form-group"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          <input
                            className={
                              "form-control-plaintext " +
                              (this.state.searchbar ? "open" : "")
                            }
                            name="searchFor"
                            value={this.state.searchFor}
                            type="search"
                            placeholder="Search Payment Request"
                            onChange={this.handleSearchBarChange}
                          />
                          <span
                          // className="d-sm-none mobile-search"
                          >
                            <Search
                              style={{
                                marginTop: "5px",
                                borderLeft: "1px solid gainsboro",
                                paddingLeft: "7px",
                                color: "gray",
                              }}
                            />
                          </span>
                        </div>
                      </form>
                    </li>
                    <li></li>
                  </div>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={this.getRefundRequestArray()}
                      pageSize={100}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allRefundRequests: state.payments.afterSale,
    allUser: state.users.users,
  };
};

export default connect(mapStateToProps, {
  getAllAfterSaleRedux,
})(RefundRequestOrder);
